import { render, staticRenderFns } from "./DelBloc.vue?vue&type=template&id=16f6792e"
import script from "./DelBloc.vue?vue&type=script&lang=js"
export * from "./DelBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports